<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="账户列表" name="list">
        <el-form :inline="true">
          <el-form-item label="店铺ID">
            <el-input
              v-model="query.shop_id"
              placeholder="店铺ID"
              clearable
              style="width: 140px"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属合作商">
            <cooperatorSelect
              :clearable="true"
              :condition="{ type: 'shop' }"
              :coopid.sync="query.coop_id"
            ></cooperatorSelect>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="query.status" placeholder="选择" clearable>
              <el-option label="正常" :value="1"></el-option>
              <el-option label="欠费" :value="2"></el-option>
              <el-option label="关闭" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">搜索</el-button>
          </el-form-item>
        </el-form>

        <auto-table
          :DataList="DataList"
          :option="Option"
          :total="Total"
          @changePage="getList"
        >
          <template #status="{ row }">
            <el-tag size="small" type="success" v-if="row.status === 1"
              >正常</el-tag
            >
            <el-tag size="small" type="danger" v-if="row.status === 2"
              >欠费</el-tag
            >
            <el-tag size="small" type="info" v-if="row.status === 3"
              >关闭</el-tag
            >
          </template>
          <template #handle="{ row }">
            <el-button size="small" type="primary" @click="openInfo(row)"
              >详情</el-button
            >
            <el-button
              size="small"
              type="success"
              v-if="row.status !== 1"
              @click="mark(row, 'markNormal')"
              >标记正常</el-button
            >
            <el-button
              size="small"
              type="warning"
              v-if="row.status === 1"
              @click="mark(row, 'markOverdue')"
              >标记欠费</el-button
            >
            <el-button
              size="small"
              type="danger"
              v-if="row.deposit_frozen > 0"
              @click="openPenalize(row)"
              >罚没押金</el-button
            >
          </template>
        </auto-table>
      </el-tab-pane>

      <el-tab-pane label="年费到期名单" name="due">
        <el-form :inline="true">
          <el-form-item label="类型">
            <el-radio-group v-model="dueQuery.type">
              <el-radio label="due">30天内到期</el-radio>
              <el-radio label="overdue">已逾期</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDueList(1)">搜索</el-button>
          </el-form-item>
        </el-form>

        <auto-table
          :DataList="DueList"
          :option="DueOption"
          :total="DueTotal"
          @changePage="getDueList"
        >
          <template #status="{ row }">
            <el-tag size="small" type="success" v-if="row.status === 1"
              >正常</el-tag
            >
            <el-tag size="small" type="danger" v-if="row.status === 2"
              >欠费</el-tag
            >
            <el-tag size="small" type="info" v-if="row.status === 3"
              >关闭</el-tag
            >
          </template>
          <template #handle="{ row }">
            <el-button
              size="small"
              type="success"
              v-if="row.status !== 1"
              @click="mark(row, 'markNormal')"
              >标记正常</el-button
            >
          </template>
        </auto-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 账户详情 -->
    <el-dialog title="账户详情" :visible.sync="infoShow" width="70%">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="店铺ID">{{
          curRow.shop_id
        }}</el-descriptions-item>
        <el-descriptions-item label="所属合作商">{{
          curRow.coop_id
        }}</el-descriptions-item>
        <el-descriptions-item label="可用余额(元)">{{
          info.available_balance
        }}</el-descriptions-item>
        <el-descriptions-item label="押金冻结(元)">{{
          info.deposit_frozen
        }}</el-descriptions-item>
        <el-descriptions-item label="累计入账(元)">{{
          info.total_income
        }}</el-descriptions-item>
        <el-descriptions-item label="累计支出(元)">{{
          info.total_expend
        }}</el-descriptions-item>
        <el-descriptions-item label="年费到期日">{{
          info.annual_fee_due_at || "未缴/免缴"
        }}</el-descriptions-item>
        <el-descriptions-item label="账户状态">
          <el-tag size="small" type="success" v-if="info.status === 1"
            >正常</el-tag
          >
          <el-tag size="small" type="danger" v-if="info.status === 2"
            >欠费</el-tag
          >
          <el-tag size="small" type="info" v-if="info.status === 3"
            >关闭</el-tag
          >
        </el-descriptions-item>
      </el-descriptions>

      <el-form :inline="true" style="margin-top: 20px">
        <el-form-item label="业务类型">
          <el-select
            v-model="logQuery.biz_type"
            placeholder="全部"
            clearable
            @change="getLog(1)"
          >
            <el-option label="年费缴纳" value="annual_fee_pay"></el-option>
            <el-option label="年费扣减" value="annual_fee_deduct"></el-option>
            <el-option label="押金缴纳" value="deposit_pay"></el-option>
            <el-option label="押金退还" value="deposit_refund"></el-option>
            <el-option label="押金罚没" value="deposit_penalty"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <auto-table
        :DataList="LogList"
        :option="LogOption"
        :total="LogTotal"
        @changePage="getLog"
      >
        <template #direction="{ row }">
          <el-tag size="small" type="success" v-if="row.direction === 1"
            >入账</el-tag
          >
          <el-tag size="small" type="warning" v-if="row.direction === 2"
            >出账</el-tag
          >
          <el-tag size="small" type="info" v-if="row.direction === 3"
            >冻结</el-tag
          >
          <el-tag size="small" v-if="row.direction === 4">解冻</el-tag>
        </template>
        <template #biz_type="{ row }">
          {{ bizTypeText(row.biz_type) }}
        </template>
      </auto-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="infoShow = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 罚没押金 -->
    <el-dialog title="罚没押金" :visible.sync="penalizeShow" width="35%">
      <el-form label-width="100px">
        <el-form-item label="店铺ID">{{
          curRow.shop_id
        }}</el-form-item>
        <el-form-item label="当前押金(元)">{{
          curRow.deposit_frozen
        }}</el-form-item>
        <el-form-item label="罚没金额" required>
          <el-input-number
            v-model="penalize_amount"
            :min="0.01"
            :max="curRow.deposit_frozen"
            :precision="2"
            :controls="false"
            style="width: 200px"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="3"
            v-model="penalize_remark"
            placeholder="罚没原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="penalizeShow = false">取 消</el-button>
        <el-button type="danger" :loading="loading" @click="penalize"
          >确认罚没</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cooperatorSelect from "@/components/select/cooperatorSelect.vue";

export default {
  components: {
    cooperatorSelect,
  },
  data() {
    return {
      nav: { firstNav: "合作商管理", secondNav: "店铺账户" },
      activeName: "list",
      DataList: [],
      Total: 0,
      query: {
        shop_id: "",
        coop_id: "",
        status: "",
      },
      Option: [
        { name: "店铺ID", value: "shop_id" },
        { name: "店铺名称", value: "shop_name" },
        { name: "所属合作商", value: "coop_id" },
        { name: "可用余额(元)", value: "available_balance" },
        { name: "押金冻结(元)", value: "deposit_frozen" },
        { name: "年费到期日", value: "annual_fee_due_at" },
        { name: "状态", value: "status", type: "custom" },
        { name: "更新时间", value: "update_time" },
        { name: "操作", value: "handle", type: "custom", width: "300px" },
      ],
      DueList: [],
      DueTotal: 0,
      dueQuery: {
        type: "due",
      },
      DueOption: [
        { name: "店铺ID", value: "shop_id" },
        { name: "店铺名称", value: "shop_name" },
        { name: "所属合作商", value: "coop_id" },
        { name: "年费到期日", value: "annual_fee_due_at" },
        { name: "状态", value: "status", type: "custom" },
        { name: "操作", value: "handle", type: "custom", width: "140px" },
      ],
      curRow: {},
      infoShow: false,
      info: {},
      LogList: [],
      LogTotal: 0,
      logQuery: {
        biz_type: "",
      },
      LogOption: [
        { name: "方向", value: "direction", type: "custom" },
        { name: "业务类型", value: "biz_type", type: "custom" },
        { name: "金额(元)", value: "amount" },
        { name: "变动后余额", value: "balance_after" },
        { name: "关联单号", value: "ref_id" },
        { name: "备注", value: "remark" },
        { name: "操作人", value: "operator_id" },
        { name: "时间", value: "create_time" },
      ],
      penalizeShow: false,
      penalize_amount: null,
      penalize_remark: "",
      loading: false,
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    bizTypeText(v) {
      const map = {
        annual_fee_pay: "年费缴纳",
        annual_fee_deduct: "年费扣减",
        deposit_pay: "押金缴纳",
        deposit_refund: "押金退还",
        deposit_penalty: "押金罚没",
      };
      return map[v] || v;
    },
    tabChange(tab) {
      if (tab.name === "due" && this.DueList.length === 0) {
        this.getDueList(1);
      }
    },
    openInfo(row) {
      this.curRow = row;
      this.logQuery.biz_type = "";
      this.infoShow = true;
      this.getInfo();
      this.getLog(1);
    },
    getInfo() {
      this.$axios({
        url: "/user/shopAccount/info",
        params: {
          shop_id: this.curRow.shop_id,
        },
      }).then((res) => {
        this.info = res.data.data || {};
      });
    },
    getLog(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/shopAccount/log",
        params: {
          shop_id: this.curRow.shop_id,
          page: page,
          size: 10,
          biz_type: this.logQuery.biz_type || null,
        },
      }).then((res) => {
        this.LogList = res.data.data.rows || [];
        this.LogTotal = res.data.data.total || 0;
      });
    },
    mark(row, action) {
      const tips = {
        markNormal: "确定将该店铺账户标记为正常吗",
        markOverdue: "确定将该店铺账户标记为欠费(冻结)吗",
      };
      this.$confirm(tips[action], "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            url: "/user/shopAccount/" + action,
            data: {
              shop_id: row.shop_id,
            },
            method: "post",
          }).then((res) => {
            this.$notify({
              message: "操作成功",
              duration: 2000,
              type: "success",
            });
            this.getList(1);
            if (this.activeName === "due") {
              this.getDueList(1);
            }
          });
        })
        .catch(() => {});
    },
    openPenalize(row) {
      this.curRow = row;
      this.penalize_amount = row.deposit_frozen;
      this.penalize_remark = "";
      this.penalizeShow = true;
    },
    penalize() {
      if (!this.penalize_amount || this.penalize_amount <= 0) {
        this.$message("请填写罚没金额");
        return;
      }
      this.loading = true;
      this.$axios({
        url: "/user/shopAccount/penalize",
        data: {
          shop_id: this.curRow.shop_id,
          amount: this.penalize_amount,
          remark: this.penalize_remark,
        },
        method: "post",
      })
        .then((res) => {
          this.$notify({
            message: "罚没成功",
            duration: 2000,
            type: "success",
          });
          this.penalizeShow = false;
          this.loading = false;
          this.getList(1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getDueList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/shopAccount/dueList",
        params: {
          type: this.dueQuery.type,
          page: page,
          size: 10,
        },
      }).then((res) => {
        this.DueList = res.data.data.rows || [];
        this.DueTotal = res.data.data.total || 0;
      });
    },
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/shopAccount/page",
        params: {
          page: page,
          size: 10,
          shop_id: this.query.shop_id || null,
          coop_id: this.query.coop_id || null,
          status: this.query.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows || [];
        this.Total = res.data.data.total || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
